import React__default from 'react';
import { Icon } from '../Icon/index.js';

const getStatusIcon = status => {
  switch (status) {
    case 'completed':
      return /*#__PURE__*/React__default.createElement(Icon, {
        color: "turquoise500",
        dataTestId: "progress-icon-completed",
        name: "CircleSmall",
        size: "medium"
      });
    case 'current':
      return /*#__PURE__*/React__default.createElement(Icon, {
        color: "turquoise500",
        dataTestId: "progress-icon-current",
        name: "CircleOutlineSmall",
        size: "medium"
      });
    case 'upcoming':
    default:
      return /*#__PURE__*/React__default.createElement(Icon, {
        color: "carbon100",
        dataTestId: "progress-icon-upcoming",
        name: "CircleSmall",
        size: "medium"
      });
  }
};
const getDirectionalStyles = _ref => {
  let {
    direction,
    status
  } = _ref;
  switch (direction) {
    case 'horizontal':
      return `
      left: 10px;
      top: 7px;
      bottom: 0;
      border-top-width: 2px;
        border-top-style: ${status === 'completed' ? 'solid' : 'dashed'};
        width: calc(100% - 20px);
        height: 3px;
        // 78 is a restrained size based on fixed content width of 140px
        margin-left: 78px;
        `;
    case 'vertical':
    default:
      return `
          height: 100%;
          left: 7px;
          top: 12px;
          bottom: 0;
          border-left-width: 2px;
          border-left-style: ${status === 'completed' ? 'solid' : 'dashed'};
          `;
  }
};
const horizontalStyles = {
  itemsStyles: {
    display: null,
    flex: 1
  },
  childrenStyles: {
    width: 140,
    top: 0
  },
  iconContainerStyles: {
    // matches figma values
    ml: '70px'
  }
};

export { getDirectionalStyles, getStatusIcon, horizontalStyles };
